import { type AccessToken } from '@shared/api/common/access-token';
import { type Observable } from 'rxjs';
import { type HttpEvent } from '@angular/common/http';
import { LoadingStatus } from '@shared/models/loading-status.enum';
import { type MediaUploadResponse } from '@shared/api/check/models/media-upload.response';
import { type MediaProcessingResponse } from '@shared/api/check/models/media-processing.response';
import { v4 as uuidv4 } from 'uuid';

export type CheckProgress = {
  training: number;
  trainingDone: boolean;
  verification: number;
  verificationDone: boolean;
};

export type QueueCompleteEvent = { result: MediaProcessingResponse };

export type VoiceConfig = {
  /** The user's access token. */
  checkToken: AccessToken;
  /** If specified, the voice phrase will be forced to be this locale. */
  locale?: string;
  /** The number of training and/or verification samples expected. */
  queue: {
    training?: number;
    verification?: number;
  };
} & (
  | {
      type: 'register';
    }
  | {
      type: 'challenge';
      challengeId: string;
    }
);

export type Recording = {
  id: string;
  status: LoadingStatus;
  upload?: Upload;
};

export function createRecording(): Recording {
  return {
    id: uuidv4(),
    status: LoadingStatus.Idle,
  };
}

export type Upload = {
  id: string;
  /** Upload progress from 0.0 to 1.0 */
  progress: number;
  transfer: Observable<HttpEvent<MediaUploadResponse>>;
  status: LoadingStatus;
};
